import React from 'react'
import CssBaseline from '@mui/material/CssBaseline';
import { Box, Toolbar, Typography } from '@mui/material';
import { GREEN_DARK, GREEN_BKG_TITLE_BAR } from '../../../assets/Styles';


export default function TitlebarAction(props: any) {
    const title = props.title

    return (
        <React.Fragment>
            <CssBaseline />
            <Box
                borderColor='primray.main'
                position="initial"
                justifyContent={'space-between'}
                display={'flex'}
                sx={{
                    backgroundColor: GREEN_BKG_TITLE_BAR,
                }}
                marginLeft={'1vw'}
                marginBottom={'0.2rem'}
                height={'2rem'}
                alignItems='center'
            >
                <Toolbar>
                    <Typography variant="button" color={`${GREEN_DARK}`}
                        style={{ fontWeight: 600, fontFamily: "Poppins" }} noWrap>
                        {title}
                    </Typography>
                </Toolbar>
            </Box>
        </React.Fragment>
    )
}